module.exports = __webpack_public_path__ + "static/media/watch-2.807dfa37.jpg";